// The user's teams: listing them, switching the app between them, copying agents across. Always on
import type { AssistantModule, ToolPolicy } from "@/lib/assistant/types"
import { makeTeamsTools, type TeamsContext } from "./tools"
import { TEAMS_INSTRUCTIONS } from "./prompt"

export type { TeamSummary, TeamsContext } from "./tools"

const policies: Record<string, ToolPolicy> = {
  team_list: { kind: "read" },
  // Changes what the user is looking at, not any data
  team_switch: { kind: "write", selfReviewed: true },
  agent_copy_to_team: { kind: "write", permission: ["agents", "create"], selfReviewed: true },
}

const labels = { team_list: "List teams", team_switch: "Switch team", agent_copy_to_team: "Copy agent to team" }

export function makeTeamsModule(ctx: TeamsContext): AssistantModule {
  return { id: "teams", title: "Teams", tools: makeTeamsTools(ctx), policies, instructions: TEAMS_INSTRUCTIONS, labels }
}
